module.exports = __webpack_public_path__ + "img/banner.d85dfa4c.jpg";